var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurveBottomBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "762px",
    height: "90px",
    viewBox: "0 0 762 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "curve_bottom_bg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "curve_bottom_bg",
    fill: "#37B5ED",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "section-curve-bottom"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M752.617906,79.7099499 C685.517997,80.731216 642.762454,7.72698495 493.244228,18.7074373 C343.726002,29.6878895 148.282456,128.105277 35.556672,72.7963318 C21.3193664,65.8107929 9.46714233,59.2777448 -2.47370642e-07,53.1971875 L-2.47370642e-07,-2.62900812e-13 L761.750784,-2.62900812e-13 C761.834051,0.113031485 761.917119,0.225942777 762,0.338733878 L762,79.1174334 C759.108252,79.4612595 755.980889,79.6587651 752.617906,79.7099499 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurveBottomBg);
export default __webpack_public_path__ + "static/media/curve_bottom_bg.7700a25d14952f8e431b4abadd69db6b.svg";
export { ForwardRef as ReactComponent };